/**
 * Определяет, какая линия должна быть отмечена в интерфейсе звонка.
 * Сохранённое значение используется, только если оно есть в актуальном списке,
 * иначе тихо откатываемся на первый доступный вариант: у менеджера мог
 * измениться набор линий или на этом компьютере работал другой пользователь.
 *
 * @param items - список линий, пришедший от бэкенда
 * @param saved - ранее сохранённая линия либо `null`
 * @returns линия для выбора либо `null`, если доступных линий нет
 */
export const resolveSelectedCallFrom = (
  items: string[],
  saved: string | null
): string | null => {
  const [firstItem] = items;

  if (firstItem === undefined) {
    return null;
  }

  if (saved !== null && items.includes(saved)) {
    return saved;
  }

  return firstItem;
};
